<template>
  <v-container fluid class="section-usecaseslightbg" id="section-usecases">
    <v-container class="py-10 pb-10">
      <!-- <v-row class="display-1 font-weight-medium text-center py-5">
        <v-col>
          <p>
            <v-icon class="blink" color="primary">mdi-color-helper</v-icon>Several use cases already supported. Otherwise, make your own
          </p>
        </v-col>
      </v-row> -->
      <v-row no-gutters>
        <template v-for="(item, i) in patrowlmanager_uc">
          <v-col :key="i">
            <v-hover
              v-slot:default="{ hover }"
            >
              <v-card
                class="pa-2lightbg"
                tile
                :elevation="hover ? 12 : 0"
              >
                <v-list-item>
                  <v-list-item-icon class="mr-4">
                    <!-- <v-icon size="60" color="primary">{{item.icon}}</v-icon> -->
                    <v-icon :size="$vuetify.breakpoint.mdAndUp ? 60 : 40" color="primary">{{item.icon}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <!-- <div class="overline mb-4">OVERLINE</div> -->
                    <!-- <v-list-item-title class="title mb-1">{{item.title}}</v-list-item-title> -->
                    <v-list-item-title
                      :class="[$vuetify.breakpoint.mdAndUp ? 'title mb-1' : 'subtitle-1 mb-1']"
                      style="white-space: normal;"
                      >{{item.title}}</v-list-item-title>
                    <v-list-item-subtitle class="subtitle-1"
                      style="white-space: normal;"
                      >{{item.details}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-hover>
          </v-col>
          <v-responsive
            v-if="i % 2"
            :key="`width-${i}`"
            width="100%"
          ></v-responsive>
        </template>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "SecUseCasesHears",
  data: () => ({
    patrowlmanager_uc: [
      { title: "Monitoring Products and Libraries", icon: "mdi-cloud-search-outline", details: "Track vulnerabilities, security bulletins, exploits and threat data related to your assets"},
      { title: "REST-API Ready", icon: "mdi-api", details: "Integrate with your SOC, CTI, Scanners, scripts, Compliance & Risk Management tools, ..."},
      { title: "Correlated and Enriched Metadata", icon: "mdi-database-import", details: "All data are cross-referenced, collected and qualified by security experts from public OSINT and private feeds"},
      { title: "Standards", icon: "mdi-lightbulb-outline", details: "Vulnerability attributes are compliant with standard references including CVE, CWE, CPE, CVSS, Mitre ATT&CK, Bulletin IDs, ..."},
      { title: "Scoring", icon: "mdi-strategy", details: "Scores are based on intrinsic vulnerability characteristics, threat topicality and your asset context as exposure, distribution and criticality"},
      { title: "Team Collaboration", icon: "mdi-account-multiple", details: "Share monitoring lists, private intelligence data and comments within your team"},
      { title: "Alerting", icon: "mdi-chat-alert-outline", details: "Get notified by Email or Slack on monitored assets"},
      { title: "Easy search", icon: "mdi-database-search", details: "Advanced search filters and unified DB enable quick security review and data analytics"},
    ]
  })
};
</script>

<style scoped>
div .theme--light.v-card.v-card--outlined {
  border: none;
}
</style>
